import { remarkSanitize } from '@nzyme/typography/remarkSanitize.js';
import { remark } from 'remark';
import remarkBehead from 'remark-behead';
const parser = remark().use(remarkBehead, { minDepth: 3 }).use(remarkSanitize);
/**
 * Parses a markdown string into a sanitized mdast AST (headings rebased to depth 3+).
 * @util
 * @__NO_SIDE_EFFECTS__
 */
export function parseMarkdown(markdown) {
    const ast = parser.parse(markdown);
    return parser.runSync(ast);
}
//# sourceMappingURL=parseMarkdown.js.map